import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import DishGroup from './DishGroup';

import { plural } from '../../../../helpers/formatPrice';
import l from '../../../../helpers/lang';
import { productProps } from '../../../../helpers/propTypes';
import { OkSign, WarningSign } from '../../../Images';

const TYPE_ONE_OF_MANY = 1;

export default class DishModification extends React.Component {
    static propTypes = {
      dish: productProps.isRequired,
      modification: PropTypes.arrayOf(
        PropTypes.shape({ m: PropTypes.number, a: PropTypes.number }),
      ),
      firstSubmit: PropTypes.bool,
      onChangeModification: PropTypes.func,
      showCart: PropTypes.bool,
    };

    static defaultProps = {
      firstSubmit: true,
      modification: [],
      onChangeModification: () => ({}),
      showCart: true,
    };

    constructor(props) {
      super(props);

      this.state = {
        modification: props.modification,
      };
    }

    isValid = () => {
      let isValid = true;
      const { dish } = this.props;

      dish.group_modifications.forEach((group) => {
        const { count } = this.getGroupSum(group);
        if (group.num_min > count) {
          isValid = false;
        }
      });

      return isValid;
    };

    changeValue = (updatedModification) => {
      let { modification } = this.state;
      const { onChangeModification } = this.props;

      // Докидываем новые модификации к текущим
      updatedModification.forEach((update) => {
        const hasMod = _.findWhere(modification, { m: update.m });
        if (!hasMod) {
          modification.push(update);
        }
      });

      // Обновляем модификации
      modification = modification.map((mod) => (
        _.findWhere(updatedModification, { m: mod.m }) || mod
      ));

      // Удаляем пустые
      modification = _.filter(modification, (mod) => mod.a);

      this.setState({ modification }, () => {
        onChangeModification(modification, !this.isValid());
      });
    };

    getGroupDescription = (group) => {
      const getPlural = (num) => (
        `${num} ${plural(num, [
          l('delivery.product.optionSingle'),
          l('delivery.product.optionFew'),
          l('delivery.product.optionMany'),
        ])}`
      );

      if (group.type === TYPE_ONE_OF_MANY) {
        return l('delivery.product.groupOneOfMany');
      }

      if (group.num_min !== 0 && group.num_max === 999) {
        return l('delivery.product.groupLowerLimit', { groupLowerLimit: getPlural(group.num_min) });
      }

      if (group.num_min === 0 && group.num_max !== 999) {
        return l('delivery.product.groupUpperLimit', { groupUpperLimit: getPlural(group.num_max) });
      }

      if (group.num_min !== 0 && group.num_max !== 999) {
        return l('delivery.product.groupUpperAndLowerLimit', {
          groupLowerLimit: group.num_min,
          groupUpperLimit: getPlural(group.num_max),
        });
      }

      return '';
    }

    getGroupSum = (group) => {
      const { modification } = this.state;
      let sum = 0;
      let count = 0;

      group.modifications.forEach((mod) => {
        const selectedMod = _.findWhere(modification, { m: mod.dish_modification_id });
        if (selectedMod) {
          sum += selectedMod.a * mod.price;
          count += selectedMod.a;
        }
      });

      return { sum, count };
    };

    // eslint-disable-next-line react/no-unused-class-component-methods
    getTotalSum = () => {
      const { dish } = this.props;

      let totalSum = dish.price;

      dish.group_modifications.forEach((group) => {
        const { sum } = this.getGroupSum(group);
        totalSum += sum;
      });

      return totalSum;
    }

    render() {
      const { modification } = this.state;
      const { dish, firstSubmit, showCart } = this.props;
      const { group_modifications: groups } = dish;

      return (
        <div id="dish-modification">
          {groups.map((group) => (
            <div key={group.dish_modification_group_id} className="modification-group">
              <div className={`h5 ${group.num_min > 0 && 'has-validation'}`}>
                {group.name}
              </div>

              {this.getGroupDescription(group) && (
                <div className="fs-6 small text-muted fw">
                  <span className="me-2">{this.getGroupDescription(group)}</span>

                  {!firstSubmit && group.num_min > this.getGroupSum(group).count && (<WarningSign />)}
                  {!firstSubmit && group.num_min <= this.getGroupSum(group).count && (<OkSign />)}
                </div>
              )}
              <DishGroup
                group={group}
                showCart={showCart}
                modification={modification}
                onChange={this.changeValue}
              />
            </div>
          ))}
        </div>
      );
    }
}
